import { render, staticRenderFns } from "./aluno-classe-estatistica.vue?vue&type=template&id=1ccc59bf&"
import script from "./aluno-classe-estatistica.vue?vue&type=script&lang=js&"
export * from "./aluno-classe-estatistica.vue?vue&type=script&lang=js&"
import style0 from "./aluno-classe-estatistica.vue?vue&type=style&index=0&id=1ccc59bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports